import React from 'react';

export function PropertyCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl overflow-hidden border border-gray-100">
      <div className="aspect-[4/3] bg-gray-100 shimmer" />
      <div className="p-5 space-y-3">
        <div className="h-6 bg-gray-100 rounded shimmer w-3/4" />
        <div className="h-4 bg-gray-100 rounded shimmer w-2/3" />
        <div className="h-3 bg-gray-100 rounded shimmer w-1/2" />
        <div className="flex gap-3 pt-3 border-t border-gray-100">
          <div className="h-4 bg-gray-100 rounded shimmer w-12" />
          <div className="h-4 bg-gray-100 rounded shimmer w-12" />
          <div className="h-4 bg-gray-100 rounded shimmer w-12" />
        </div>
      </div>
    </div>
  );
}

export function PropertyCardSkeletonGrid({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, i) => <PropertyCardSkeleton key={i} />)}
    </div>
  );
}

export function TextSkeleton({ width = 'w-full', height = 'h-4', className = '' }) {
  return <div className={`${width} ${height} bg-gray-100 rounded shimmer ${className}`} />;
}
